<ng-container [formGroup]="parentFormGroup">
  <pg-field [size]="stateSelectInputModel?.size">
    <label pgLabel>{{ stateSelectInputModel?.label }}</label>

    <input
      pgInput
      #input="pgInput"
      [placeholder]="stateSelectInputModel?.placeholder"
      [disabled]="stateSelectInputModel?.disabled"
      [formControlName]="stateSelectInputModel?.formControlName"
      (input)="handleBehaviorEvent('onInput', $event)"
      [id]="stateSelectInputModel?.id"
      (focus)="handleBehaviorEvent('onFocus', $event)"
      (blur)="handleBehaviorEvent('onBlur', $event)"
      (input)="handleBehaviorEvent('onInput', $event)"
    />

    <pg-subscript-messages>
      <span *ngIf="stateSelectInputModel?.hint" pgHint>{{
        stateSelectInputModel.hint
      }}</span>

      <span
        *ngFor="let validation of stateSelectInputModel?.validationList"
        pgError
        [for]="validation.errorKey"
        >{{ validation.message }}</span
      >
    </pg-subscript-messages>
    <pg-suffix-icons>
      <pg-icon
        *ngFor="let icon of stateSelectInputModel?.suffixIcons"
        pgSuffixIcon
        [visible]="!icon.hidden"
        [style.cursor]="icon.onClick && icon.onClick.length ? 'pointer' : null"
        >{{ icon.iconName }}</pg-icon
      >
      <pg-icon class="fg-red400" pgSuffixIcon [visible]="input.isError"
        >warning</pg-icon
      >
      <pg-icon
        class="fg-green500"
        pgSuffixIcon
        [visible]="
          !stateSelectInputModel.validationIconDisabled &&
          !input.isError &&
          !input.isEmpty &&
          !input.isFocused &&
          !input.isDisabled &&
          !stateSelectInputModel.loading
        "
        >done</pg-icon
      >

      <pg-spinner
        pgSuffixIcon
        [visible]="stateSelectInputModel?.loading"
      ></pg-spinner>
    </pg-suffix-icons>
    <pg-prefix-icons *ngIf="stateSelectInputModel?.prefixIcon">
      <pg-icon pgPrefixIcon>{{
        stateSelectInputModel.prefixIcon.iconName
      }}</pg-icon>
    </pg-prefix-icons>

    <pg-field-bottom-border-gap>
      <pg-drop-down>
        <span
          pgDropDownItem
          *ngFor="let item of searchTerms"
          [searchableTerms]="item.searchTerms"
          [value]="item.value"
          >{{ item.display }}</span
        >
      </pg-drop-down>
    </pg-field-bottom-border-gap>
  </pg-field>
</ng-container>
